module.exports = "/_next/static/images/2-62ef1265cbddf49f1dee744898763798.jpg";